import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_OBTENIR_EN_CURS,
    AVIS_VISUALITZACIO_OBTENIR_FINALITZADA } from '../../../../actions/actionTypes';

const ESTAT_INICIAL_PETICIO_OBTENIR_EN_CURS = false;

const peticioObtenirEnCurs = (state = ESTAT_INICIAL_PETICIO_OBTENIR_EN_CURS, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL_PETICIO_OBTENIR_EN_CURS;

        case AVIS_VISUALITZACIO_OBTENIR_EN_CURS:
            return true;

        case AVIS_VISUALITZACIO_OBTENIR_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioObtenirEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/avisos/peticioObtenirEnCurs.js